const actions = {
  setCreditRating: 'SET_CREDIT_RATING',
  setCreditReview: 'SET_CREDIT_REVIEW',
  setESGScore: 'SET_ESG_SCORE',
  setESGSentiment: 'SET_ESG_SENTIMENT',
};

const setIsLoading = (type, isLoading) => ({ type, isLoading });
const initialLoadingState = {
  creditRating: true,
  creditReview: true,
  esgSentiment: true,
};
const isLoadingReducer = (state, action) => {
  switch (action.type) {
    case actions.setCreditRating:
      return { ...state, creditRating: action.isLoading };
    case actions.setCreditReview:
      return { ...state, creditReview: action.isLoading };
    case actions.setESGSentiment:
      return { ...state, esgSentiment: action.isLoading };
    default:
      throw new Error();
  }
};
const setData = (type, data) => ({ type, data });
const initialDataState = {
  creditRating: {},
  creditReview: {},
  esgSentiment: {},
};
const dataReducer = (state, action) => {
  switch (action.type) {
    case actions.setCreditRating:
      return { ...state, creditRating: action.data };
    case actions.setCreditReview:
      return { ...state, creditReview: action.data };
    case actions.setESGSentiment:
      return { ...state, esgSentiment: action.data };
    default:
      throw new Error();
  }
};
const setStatus = (type, status, value) => ({ type, status, value });
const initialStatusState = {
  creditRating: {
    isAvailable: false,
    wasRequested: false,
  },
  creditReview: {
    isAvailable: false,
    wasRequested: false,
  },
  esgSentiment: {
    isAvailable: false,
    dataExists: false,
  },
};
const statusReducer = (state, action) => {
  switch (action.type) {
    case actions.setCreditRating:
      return {
        ...state,
        creditRating: {
          ...state.creditRating,
          [action.status]: action.value,
        },
      };
    case actions.setCreditReview:
      return {
        ...state,
        creditReview: {
          ...state.creditReview,
          [action.status]: action.value,
        },
      };
    case actions.setESGScore:
      return {
        ...state,
        esgScore: {
          ...state.esgScore,
          [action.status]: action.value,
        },
      };
    case actions.setESGSentiment:
      return {
        ...state,
        esgSentiment: {
          ...state.esgSentiment,
          [action.status]: action.value,
        },
      };
    default:
      throw new Error();
  }
};
const setSubscribed = (type, status, value) => ({ type, status, value });
const initialSubscribedState = {
  creditRating: {
    isSubscribed: false,
  },
  esgScore: {
    isSubscribed: false,
  },
  esgSentiment: {
    isSubscribed: false,
  },
};
const subscribedReducer = (state, action) => {
  switch (action.type) {
    case actions.setCreditRating:
      return {
        ...state,
        creditRating: {
          ...state.creditRating,
          [action.status]: action.value,
        },
      };
    case actions.setESGScore:
      return {
        ...state,
        esgScore: {
          ...state.esgScore,
          [action.status]: action.value,
        },
      };
    case actions.setESGSentiment:
      return {
        ...state,
        esgSentiment: {
          ...state.esgSentiment,
          [action.status]: action.value,
        },
      };
    default:
      throw new Error();
  }
};

export {
  actions,
  setIsLoading,
  initialLoadingState,
  isLoadingReducer,
  setData,
  initialDataState,
  dataReducer,
  setStatus,
  initialStatusState,
  statusReducer,
  setSubscribed,
  initialSubscribedState,
  subscribedReducer,
};
